import api from '../api/client';

export const motoristasService = {
  listar: (organizadorId) =>
    api.get(`/organizadores/${organizadorId}/motoristas`),

  buscar: (organizadorId, q) =>
    api.get(`/organizadores/${organizadorId}/motoristas/buscar`, { params: { q } }),

  criar: (organizadorId, dados) =>
    api.post(`/organizadores/${organizadorId}/motoristas`, dados),

  atualizar: (organizadorId, id, dados) =>
    api.put(`/organizadores/${organizadorId}/motoristas/${id}`, dados),

  excluir: (organizadorId, id) =>
    api.delete(`/organizadores/${organizadorId}/motoristas/${id}`),

  adicionarCaminhao: (organizadorId, motoristaId, dados) =>
    api.post(`/organizadores/${organizadorId}/motoristas/${motoristaId}/caminhoes`, dados),

  removerCaminhao: (organizadorId, motoristaId, caminhaoId) =>
    api.delete(`/organizadores/${organizadorId}/motoristas/${motoristaId}/caminhoes/${caminhaoId}`),
};

